import React from 'react';
import { Info } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export interface SavingsMetricCardProps {
  title: string;
  tooltipText: string;
  amount: number;
  periodLabel: string;
  subtitle: string;
  buttonLabel: string;
  onButtonClick: () => void;
}

const formatCurrency = (amount: number) =>
  amount.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const SavingsMetricCard: React.FC<SavingsMetricCardProps> = ({
  title,
  tooltipText,
  amount,
  periodLabel,
  subtitle,
  buttonLabel,
  onButtonClick,
}) => {
  return (
    <div className="border-2 border-red-300 rounded-xl bg-white dark:bg-background p-6">
      <div className="space-y-1">
        <div className="flex items-center gap-1.5">
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Info className="h-3.5 w-3.5 text-muted-foreground cursor-help" />
              </TooltipTrigger>
              <TooltipContent className="max-w-xs">
                <p>{tooltipText}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-bold text-red-500 dark:text-red-400">
            ${formatCurrency(amount)}
          </span>
          <span className="text-sm text-muted-foreground">{periodLabel}</span>
        </div>
        <p className="text-xs text-muted-foreground">{subtitle}</p>
      </div>

      <Button
        className="w-full mt-5 bg-blue-500 hover:bg-blue-600 text-white font-medium py-5 rounded-lg"
        onClick={onButtonClick}
      >
        {buttonLabel}
      </Button>
    </div>
  );
};

export default SavingsMetricCard;
